import apiService from './apiServices';

const apiRequest = async (url: string, method: 'GET' | 'POST' | 'PUT' | 'DELETE' = 'GET', body: any = {}) => {
  try {
    let response;

    switch (method) {
      case 'GET':
        response = await apiService.get(url);
        break;
      case 'POST':
        response = await apiService.post(url, body);
        break;
      case 'PUT':
        response = await apiService.put(url, body);
        break;
      case 'DELETE':
        response = await apiService.delete(url);
        break;
      default:
        throw new Error('Unsupported method');
    }
    return { data: response };
  } catch (error: any) {
    return { error: { message: error.message } };
  }
};

export default apiRequest;
